<template>
  <footer class="footer">
      <v-landing-container small>
      <div class="footer__content">
        <span
          class="footer__copyright"
        >© {{ new Date().getFullYear() }} {{ $t('v.home.copyright') }}</span>
        <div class="footer__links">
          <router-link
            class="footer__link"
            :to="{ name: 'terms-of-service' }"
          >{{ $t('v.home.linkTermsText') }}</router-link>
          <router-link
            class="footer__link"
            :to="{ name: 'pdp-policy' }"
          >{{ $t('v.home.linkPrivacyPolicy') }}</router-link>
        </div>
        <div class="footer__socials">
          <a class="footer__button" href="https://www.facebook.com/banhammer420" target="_blank">
            <img src="/i_facebook.svg" alt="Facebook Icon" />
          </a>
          <a class="footer__button" href="https://vk.com/bnhmmr" target="_blank">
            <img src="/i_vk.svg" alt="Product Hunt Icon"/>
          </a>
        </div>
      </div>
    </v-landing-container>
  </footer>
</template>

<script>
import VLandingContainer from '@/components/Landing/VLandingContainer.vue'

export default {
  name: 'Footer',
  components: { VLandingContainer }
}
</script>

<style lang="scss" scoped>
@import "../../assets/style/scss/vars";
@import "../../assets/style/scss/extends";

.footer {
  @extend %flex-column;
  background-color: $white;
  align-items: center;
}
.footer__content {
  @extend %flex-row;
  max-width: 950px;
  width: 100%;
  padding: 32px 0 68px;
  align-items: center;
  justify-content: space-between;
  font-size: 17px;
}

.footer__copyright {
  font-family: $font-cabin;
  font-weight: map-get($font-weight, "semi-bold");
  flex-basis: 181px;
  font-size: 17px;
  color: $gray-shades;
  margin-right: 9%;
}
.footer__socials {
  @extend %flex-row;
}
.footer__button {
  &:not(:last-child) {
    margin-right: 16px;
  }
}

.footer__links {
  @extend %flex-row;
  font-family: $font-cabin;
  flex-basis: 400px;
  justify-content: flex-end;
  margin-right: 20%;
}
.footer__link {
  color: $gray-shades;
  border-bottom: 1px solid $gray-shades;

  &:not(:last-child) {
    margin-right: 12px;
  }
}
</style>
